<template>
  <div class="flex container">
    <va-button class="alignright" color="gray" @click="showAddDomainModal">Add New Domain</va-button>
    <va-modal v-model="showAddNewDomainModal" overlay-opacity="0.2" size="medium" hide-default-actions blur>
      <template #header>
        <h2>New Domain to Whitelist</h2>
      </template>
      <EditDomainWhitelistModal @close="closeDomainWhitelist" />
    </va-modal>
    <va-data-table class="domain-whitelist" :items="domains" :columns="columns" striped :per-page="perPage"
      :current-page="currentPage" animated=true no-data-html="No whitelist domains" :style="{
        'font-size': '14px',
        'font-family': 'Proxima',
        'font-weight': 'bold',
        '--va-data-table-thead-font-size': '.9rem'
      }">
      <template v-slot:actions="props">
        <!-- <va-button small @click="update(props.rowData)">
          UPDATE
        </va-button> -->
        <!-- <va-button small @click="disable(props.rowData)">
          DISABLE
        </va-button> -->
        <va-button color="gray" small @click="remove(rowIndex)">
          DELETE
        </va-button>
      </template>
      <template #cell(actions)="{ rowIndex }">
        <!-- <va-button @click="update(rowIndex)">Enable Domain</va-button> -->
        <!-- <va-button @click="disable(rowIndex)">Disable Domain</va-button> -->
        <va-button flat icon="delete" color="gray" @click="remove(rowIndex)" />
      </template>
      <template #bodyAppend>
        <tr>
          <td colspan="8" class="whitelist--pagination">
            <va-pagination v-model="currentPage" :pages="pages" hide-on-single-page />
          </td>
        </tr>
      </template>
    </va-data-table>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import EditDomainWhitelistModal from '@/modules/admin/components/EditDomainWhitelistModal.vue'

export default {
  name: 'domain-management',
  components: {
    EditDomainWhitelistModal
  },
  data() {
    const domains = [];
    const columns = [
      { key: 'name', title: 'Domain Name', sortable: true, width: '50%' },
      { key: 'status', title: 'Current Domain Status', sortable: true, width: '20%' },
      { key: 'actions', dataClass: 'text-right' }
    ];
    const additionalStyle = {
      color: "white",
      fontWeight: 900
    };
    return {
      columns,
      additionalStyle,
      currentPage: 1,
      perPage: 10,
      showAddNewDomainModal: false
      // filter: '',
      // filtered: domains,
    }
  },
  computed: {
    ...mapState({
      domains: state => state.admin.domainWhitelist ? state.admin.domainWhitelist.domainWhitelist : [],
      selectedEntity: state => state.user.selectedEntity
      //pages to come later
    })
  },
  methods: {
    ...mapActions({
      getDomainWhitelist: 'admin/getDomainWhitelist',
      toggleDomain: 'admin/toggleDomainStatusFromWhitelist',
      deleteDomain: 'admin/deleteDomainFromWhitelist'
    }),
    // update(index) {
    //   if (confirm('Are you sure you want to enable the domain?')) {
    //     const domain = this.domains[index];
    //     this.toggleDomain({ entityId: this.selectedEntity.id, domainName: domain.name });
    //     this.getDomainWhitelist({ entityId: this.selectedEntity.id })
    //   }

    // },
    // disable(index) {
    //   if (confirm('Are you sure you want to disable the domain?')) {
    //     const domain = this.domains[index];
    //     this.toggleDomain({ entityId: this.selectedEntity.id, domainName: domain.name });
    //     this.getDomainWhitelist({ entityId: this.selectedEntity.id })
    //     this.$vaToast.init({ message: 'Disabled domain successfully', color: 'success' })
    //   }

    // },
    remove(index) {
      if (confirm('Are you sure you want to remove the domain?')) {
        const domain = this.domains[index];
        // this.toggleDomain({ entityId: this.selectedEntity.id, domainName: domain.name });
        this.deleteDomain({ entityId: this.selectedEntity.id, domainName: domain.name });
        this.getDomainWhitelist({ entityId: this.selectedEntity.id })
        this.$vaToast.init({ message: 'Deleted Domain Successfully', color: 'success' })
      }

    },
    close() {
      console.log('close the domain')
    },
    showAddDomainModal() {
      this.showAddNewDomainModal = true;
    },
    closeDomainWhitelist() {
      this.showAddNewDomainModal = false
      this.getDomainWhitelist({ entityId: this.selectedEntity.id })
    }
  },
  mounted() {
    if (this.selectedEntity) {
      this.getDomainWhitelist({ entityId: this.selectedEntity.id })
    }
  }
}
</script>


<style lang="scss" scoped>
.whitelist--pagination {
  text-align: center;
  text-align: -webkit-center;
}

.container {
  padding: 0.75rem;
  padding-top: 1rem;
  color: black;
  background: white;
  border-radius: 0.375rem;
  box-shadow: 0px 0px 24px 5px #000;
  -moz-box-shadow: 0px 0px 24px 5px #000;
  -webkit-box-shadow: 0px 0px 24px 5px #000;
  display: flex;
  flex-direction: column;
  align-items: flex-end;


}

.alignright {
  float: right;
}
</style>